globalThis.PasswordGenerator = (function() {
  function PasswordGenerator($form) {
    this.$html           = $form;
    this.$passwordInput  = this.$html.find("input[type='password']");
    this.$clipboard      = this.$html.find(".clipboard");
    this.$feedback       = this.$html.find(".form-control-feedback > span > i");
    this.$output         = this.$html.find("#generated-password");

    this.$generateButton = this.$html.find("#generate-password");
    this.ajaxUrl         = this.$generateButton.data("ajax-url");
    this.$spinner        = this.$generateButton.find("i");

    if(this.$generateButton.length && this.ajaxUrl && this.$output.length) {
      this.init();
    }
  }

  PasswordGenerator.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var generator = this;

      generator.$generateButton.on("click", function() {
        generator.startSpinner();

        $.ajax({
          url: generator.ajaxUrl,
          type: "GET",
          success: function(data) {
            if(data.response == 1 && data.password.length) {
              generator.renderPassword(data.password);
            } else {
              generator.renderError();
            }
            generator.endSpinner();
          }
        })
      })
    },
    startSpinner: function() {
      this.$feedback.removeClass("text-success text-danger");
      this.$feedback.addClass("fa-circle-o-notch fa-spin");
    },
    endSpinner: function() {
      this.$feedback.removeClass("fa-circle-o-notch fa-spin");
    },
    renderPassword: function(string) {
      this.$clipboard.removeAttr("disabled");
      this.$clipboard.attr("data-clipboard-text", string)
      this.$feedback.addClass("fa-check text-success");
      // Don't forget to trigger keyup event
      this.$passwordInput.val(string).trigger("keyup");
      this.$output.css("font-family", "Monospace");
      this.$output.val(string);
    },
    renderError: function() {
      this.$feedback.addClass("fa-times text-danger")
      this.$output.text("Une erreur est survenue");
    }
  }

  return PasswordGenerator;
})();
